import React from 'react';
import cssClass from './Footer.module.css';
import setuLogo from '../assets/setu-header-img.svg';

/**
 * Footer Component
 *
 * Displays the footer section with company details and navigation links.
 *
 * Features:
 * - Displays the company logo, email, and address.
 * - Provides links for "About Us," "Blogs," and "Contact Us."
 * - Includes legal links like Privacy Policy, Terms & Conditions, and Refund Policy.
 */
const Footer = () => {
  const redirectToLink = (URL) => {
    window.open(URL, '_blank');
  };

  const footerLinks = {
    about: 'https://ai.setuschool.com/about',
    blog: 'https://ai.setuschool.com/all/blog',
    contact: 'https://ai.setuschool.com/contact',
    privacyPolicy: 'https://ai.setuschool.com/privacy_policy',
    terms_and_condition: 'https://ai.setuschool.com/terms_condition',
    refund_policy: 'https://ai.setuschool.com/return_refund',
  };

  return (
    <div className={cssClass['footer']}>
      <div className={cssClass['footer-first']}>
        <img src={setuLogo} alt="" className={cssClass['logo']} />
        <p>
          <span className={cssClass['contact-type-span']}>Email :</span>{' '}
          mitra@setuschool.com
        </p>
        <p>
          <span className={cssClass['contact-type-span']}>
            Phone & Whatsapp :
          </span>{' '}
          8100551189
        </p>
        <p>
          SETU, Awfis co-working space, 6th floor, Phase II,
          <br />
          50, Chowringee Road, Elgin, Kolkata, west Bengal 700071{' '}
        </p>
      </div>

      <div className={cssClass['footer-last-div']}>
        <div className={cssClass['footer-last']}>
          <h3>About</h3>
          <p onClick={() => redirectToLink(footerLinks.about)}>About us</p>
          <p onClick={() => redirectToLink(footerLinks.blog)}>Blogs</p>
          <p onClick={() => redirectToLink(footerLinks.contact)}>Contact us</p>
        </div>
        <div className={cssClass['footer-last']}>
          <p onClick={() => redirectToLink(footerLinks.privacyPolicy)}>
            Privacy Policy
          </p>
          <p onClick={() => redirectToLink(footerLinks.terms_and_condition)}>
            Terms & Conditions
          </p>
          <p onClick={() => redirectToLink(footerLinks.refund_policy)}>
            Return & Refund Policy
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
